var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative" }, [
    _c(
      "div",
      {
        staticClass: "vx-navbar-wrapper",
        class: _vm.classObj,
        staticStyle: { "z-index": "1000" }
      },
      [
        _c(
          "vs-navbar",
          {
            staticClass: "vx-navbar navbar-custom navbar-skelton py-1",
            class: _vm.textColor,
            attrs: { color: _vm.navbarColorLocal }
          },
          [
            _vm.view !== "compartido"
              ? _c("feather-icon", {
                  staticClass: "sm:inline-flex xl:hidden cursor-pointer",
                  attrs: { size: "20", icon: "MenuIcon" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showSidebar($event)
                    }
                  }
                })
              : _vm._e(),
            _vm.windowWidth >= 992
              ? _c("bookmarks", { attrs: { navbarColor: _vm.navbarColor } })
              : _vm._e(),
            _c("vs-spacer"),
            _c("profile-drop-down")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }